import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { AccountSetupHelperService } from '../../../account-setup-helper.service';

@Component({
  selector: 'app-logo-selector',
  templateUrl: './logo-selector.component.html',
  styleUrls: ['./logo-selector.component.css'],
})
export class LogoSelectorComponent implements OnInit, OnChanges {
  @Input() hubName = '';
  @Input() selectedPalette: any;
  @Input() logoUrl: string | null = null;
  @Output() logoChange = new EventEmitter<string | File | null>();

  @Input() mode: 'none' | 'placeholder' | 'upload' = 'none';
  @Output() modeChange = new EventEmitter<'none' | 'placeholder' | 'upload'>();
  previewUrl: string | null = null;

  constructor(public accountSetupHelperService: AccountSetupHelperService) {
  }

  ngOnInit(): void {
    this.previewUrl = this.accountSetupHelperService.wizardData.hubInput.hubBranding.placeHolderLogo;
    // Ensure we have an up-to-date placeholder if we are in that mode
    if (this.mode === 'placeholder') {
      this.regenerateLogo();
    }
  }

  /** React to input changes */
  ngOnChanges(changes: SimpleChanges): void {
    // 🔁 If we're in placeholder mode and hubName, colorPalette, or mode changed → regenerate
    if (
      this.mode === 'placeholder' &&
      (changes['hubName'] || changes['selectedPalette'] || changes['mode'])
    ) {
      this.regenerateLogo();
    }
  }

  regenerateLogo() {
    const logo = this.generatePlaceholder(this.selectedPalette);
    this.setGeneratedPlaceholder(logo);
  }

  silentGeneration() {
    const logo = this.generatePlaceholder(this.selectedPalette);
    this.accountSetupHelperService.wizardData.hubInput.hubBranding.placeHolderLogo = logo;
  }
  setGeneratedPlaceholder(logo: string) {
    if (!logo) {
      this.accountSetupHelperService.wizardData.hubInput.hubBranding.placeHolderLogo = null;
      return;
    }
    this.previewUrl = logo;
    this.accountSetupHelperService.wizardData.hubInput.hubBranding.placeHolderLogo = logo;
    this.logoChange.emit(this.previewUrl);
  }

  /** Generate placeholder logo dynamically */
  generatePlaceholder(
    selectedPalette: { colors: string[] } = this.accountSetupHelperService.wizardData.hubInput.hubBranding.colorPalette
  ): string {
    const hubName = this.hubName?.trim() || 'Hub';
    const initial = hubName[0].toUpperCase();

    const palette = selectedPalette?.colors?.length
      ? selectedPalette
      : { colors: ['#F5F7FA', '#E4E7EB', '#CBD2D9', '#9AA5B1', '#7B8794'] };
    const colors = palette.colors;

    const iconSize = 128;
    const padding = 24;
    const fontSize = 64;
    const textWidth = hubName.length * (fontSize * 0.6);
    const canvasWidth = iconSize + padding + textWidth;
    const canvasHeight = iconSize;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;

    // 🎨 gradient background
    const gradient = ctx.createLinearGradient(0, 0, iconSize, iconSize);
    gradient.addColorStop(0, colors[0]);
    gradient.addColorStop(1, colors[4]);
    ctx.fillStyle = gradient;

    // rounded square
    const radius = 24;
    ctx.beginPath();
    ctx.moveTo(radius, 0);
    ctx.lineTo(iconSize - radius, 0);
    ctx.quadraticCurveTo(iconSize, 0, iconSize, radius);
    ctx.lineTo(iconSize, iconSize - radius);
    ctx.quadraticCurveTo(iconSize, iconSize, iconSize - radius, iconSize);
    ctx.lineTo(radius, iconSize);
    ctx.quadraticCurveTo(0, iconSize, 0, iconSize - radius);
    ctx.lineTo(0, radius);
    ctx.quadraticCurveTo(0, 0, radius, 0);
    ctx.closePath();
    ctx.fill();

    // initial
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 72px Inter, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initial, iconSize / 2, iconSize / 2 + 4);

    // hub name text
    const textColor = colors[4];
    ctx.fillStyle = textColor;
    ctx.font = 'bold 64px Inter, sans-serif';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.fillText(hubName, iconSize + padding, canvasHeight / 2 + 4);

    return canvas.toDataURL('image/png');
  }

  /** Mode selection */
  switchMode(mode: 'placeholder' | 'upload') {
    this.mode = mode;
    this.modeChange.emit(mode)

    if (mode === 'placeholder') {
      const logo = this.generatePlaceholder();
      this.setGeneratedPlaceholder(logo)
    } else {
      this.setGeneratedPlaceholder(null)
    }
  }

  /** Upload */
  // onFileSelected(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   if (!input.files?.length) return;

  //   const file = input.files[0];
  //   const validTypes = ['image/png', 'image/jpeg', 'image/svg+xml'];
  //   if (!validTypes.includes(file.type)) {
  //     alert('Only PNG, JPEG, or SVG formats are allowed.');
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onload = () => (this.previewUrl = reader.result as string);
  //   reader.readAsDataURL(file);

  //   this.logoChange.emit(file);
  // }

  removeLogo() {
    this.previewUrl = null;
    this.mode = 'none';
    this.logoChange.emit(null);
  }
}
